import type { CreateWebsiteBannerDto } from '@/generated/korza-api-client/types.gen';
import { useI18nContext } from '@/i18n/i18n-react';
import { bannerPlainText } from '@/lib/website-banner-constants';

export interface SiteBannerStaticPreviewProps {
  content: CreateWebsiteBannerDto['content'];
  theme: CreateWebsiteBannerDto['theme'];
}

/** Fallback when the backend preview is unavailable: theme colours, text without tags, button. */
export function SiteBannerStaticPreview({
  content,
  theme,
}: SiteBannerStaticPreviewProps) {
  const { LL } = useI18nContext();
  return (
    <div>
      <div
        data-static-banner
        className="flex items-center justify-between gap-2 px-3 py-2 text-[11px]"
        style={{ backgroundColor: theme.bgColor, color: theme.fgColor }}
      >
        <span className="min-w-0">{bannerPlainText(content.textHtml)}</span>
        <span
          className="shrink-0 rounded px-2 py-1 font-semibold"
          style={{ backgroundColor: theme.fgColor, color: theme.bgColor }}
        >
          {content.buttonText}
        </span>
      </div>
      <p className="px-3 py-1 text-[10px] text-neutral-500">
        {LL.websiteBannerEditor.canvas.simplifiedPreview()}
      </p>
    </div>
  );
}
